import script from "./AppNavigation.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppNavigation.vue?vue&type=script&setup=true&lang=ts"

import "./AppNavigation.vue?vue&type=style&index=0&id=c96381c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c96381c0"]])

export default __exports__